import { Component, Vue } from "vue-facing-decorator";

@Component({
    name: "OaiViewComponent",
})
export default class OaiViewComponent extends Vue {}
